import { css } from 'styled-components';

export const diffuseGlass = css`
    background: rgba(255, 255, 255, 0.8); /* semi-transparent */
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(10px); /* Safari */
`;
